module.exports = __webpack_public_path__ + "static/img/cor-xtjc.800c68b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cor-xtjc.png
// module id = ly8h
// module chunks = 0